import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { UserService } from 'src/app/services/Modules/user.service';
import { DrivePhraseService } from '../../drive-phrases/drive-phrase.service';
import { USER_TYPE } from '../../global';


@Component({
  selector: 'app-add-user-phrase-to-provider',
  templateUrl: './add-user-phrase-to-provider.component.html',
  styleUrls: ['./add-user-phrase-to-provider.component.css']
})

export class AddUserPhraseToProviderComponent implements OnInit {
  providers: any = [];
  selectedProvider;
  phraseArray: any = [];
  providertoShare: any;
  currentUser: any;
  providerDropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'fullName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 10,
    allowSearchFilter: true,
    enableCheckAll: true,
  };
  sharedProviders: any = [];
  companies: any;
  company_id: any;
  selectedCompany: any;
  searchCompanyText: any = '';
  
  constructor(public dialogRef: MatDialogRef<AddUserPhraseToProviderComponent>,
    private drivePhraseService: DrivePhraseService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastr: ToastrService,
    private companyService : CompanyService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.currentUser = this.authService.currentUser._id;
    if (data) {
      // this.providers = data.providers.filter((ele) => ele._id != this.data.selectedProviderId);
      this.phraseArray = data.phrase;
    }
    // this.providers.forEach(element => {
    //   element['fullName'] = element['first_name'] + ' ' + element['last_name'];
    // });
    // console.log(this.providers);
    // this.selectedProvider = this.providers[0];
  }

  async ngOnInit() {
    this.company_id = this.currentUser.company_id;
    await this.initAssociatedCompanies();
  }
  
  onCompanyChange($event) {
    this.selectedCompany = $event.value;
    this.getProviders();
  }

  async initAssociatedCompanies() {
    let query = {
      adminId: this.currentUser._id,
      parentCompanyId: this.data.company_id
    }
    this.companyService.getAllAssosiatedCompaniesWithCount(query).subscribe((response: any) => {
      if (response.status == 200) {
        this.companies = response.data;
        this.companies.forEach(company => {
          if(this.company_id === company._id) {
            this.selectedCompany = company._id;
            this.getProviders();
          }
        });
      }
      else if (response.status == 403) {
        this.toastr.error(response.message, "ERROR");
      }

    })
  }

  async getProviders() {
    // const company_id = this.params.id;
    const filter = {
      is_activated: 'true',
      user_type: USER_TYPE.DOCTOR,
      company_id: this.selectedCompany
    }
    const projection = {
      'account_type': 1,
      'first_name': 1,
      'last_name': 1,
      'title': 1,
    }

    const companyUsersResponse: any = await this.userService.getUsers(filter, projection).toPromise();
    if (companyUsersResponse.status === 200) {
      let providerss = companyUsersResponse.data.map(p => Object.assign(p, {
        fullName: p.account_type === 'company' ?
          `${p.first_name} ${p.last_name}, ${p.title} (company owner)` :
          `${p.first_name} ${p.last_name}, ${p.title}`
      }));
      this.providers = providerss.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
      this.selectedProvider = this.providers[0];
    }
    // this.getSystemPhrases();
  }

  onProviderClick(providerId) {
    this.providertoShare = providerId;
  }

  importPhrases(sharedProviderId, sharedProviderIds = null) {
    if (sharedProviderIds) {
      sharedProviderId = null;
    }
    this.drivePhraseService.saveNoteBuilderDictionaryAdmin(sharedProviderId, this.phraseArray, sharedProviderIds).subscribe((response: any) => {
      console.log(response);
      if (response.status === 200) {
        this.toastr.success('Shared successfully!');
      }
    })
  }

  onProviderSelect($event) {
    if (this.sharedProviders.indexOf($event._id) === -1) {
      this.sharedProviders.push($event._id);
    }
    // this.importPhrases($event._id);
  }
  onProviderDeselect($event) {
    const index = this.sharedProviders.findIndex(providerId => providerId === $event._id);
    if (index !== -1) {
      this.sharedProviders.splice(index, 1);
    }
  }
  sharePharses() {
    this.importPhrases(null, this.sharedProviders);
  }
  onAllProviderSelect(providers) {
    const allProviders = providers.map(provider => provider._id);
    for (const id of allProviders) {
      if (!this.sharedProviders.includes(id)) {
        this.sharedProviders.push(id);
      }
    }
  }
  onAllProviderDeSelect($event) {
    this.sharedProviders = $event;
  }
}
